<template>
  <div class="sdgs-container">
    <div class="header">
      UNSERE VISION
    </div>
    <div class="separator"></div>
    <div class="content programme-block">
      <div class="programme-item">
        Die Welt ist im Wandel, und Weiden mittendrin. Das 21. Jahrhundert hat
        Herausforderungen für uns in Peto, die ungeahnte Chancen, aber auch
        ungeahnte Bedrohungen beinhalten.
        <br>
        <br>
        Der Klimawandel, das größte Artensterben aller Zeiten und die
        Digitalisierung. Alle Themen die kaum abstrakter sein könnten und häufig
        wie etwas erschein was am fernen Horizont ist, und doch nur "die große
        Welt betreffen".
        <br>
        <br>
        Aber auch Weiden ist betroffen von einem Rückgang der Artenvielfalt, von
        einer ausufernden Klimakrise und von den Veränderung in Gesellschaft und
        Wirtschaft durch den immer stärkeren Einsatz von digitalen Werkzeugen.
        <br>
        <br>
        All das hat Auswirkungen auf unser tägliches Leben im schönen Weiden,
        all das wird uns die kommenden Jahrzehnte stark beschäftigen. Und nur
        wenn wir bereits jetzt die Weichen richtig stellen werden wir als Stadt
        gestärkt aus diesen Krisen hervorgehen statt abgehängt zu werden.
        <div class="larger">
          Darum Grün wählen!
        </div>
         Wir sind die einzige progressive und mutige Partei, die Antworten auf die
         Herausforderungen der Gegenwart und für die Zukunft hat. In Weiden
         Grün wählen heißt, eine lebenswerte Zukunft wählen, nicht nur für uns,
         sondern auch unsere Kinder und Enkel!
      </div>

      <div class="programme-item">
        <div class="photo">
          <img class="photo" :src="'/img/photos/Gruppenfoto1.jpg'">
        </div>
        Euer Team von den Grünen in Weiden!
      </div>
    </div>



    <div class="back-button" @click="goBack()">
      <i class="fas fa-chevron-circle-left"></i>
    </div>
   
  </div>
</template>

<script>

export default {
  name: 'Vision',
  components: {
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.sdgs-container {
  position: relative;
  @include gradient;
  min-height: 100%;
  color: $primary;
}

.larger {
  font-size: 18pt;
  align: center;
  margin: 15px;
}
.back-button {
  position: absolute;
  bottom: 20px;
  right: 20px;
  font-size: 40px;
}

.photo {
  display: block;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  width: 90%;
}

</style>
